var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"small-box",class:_vm.custom_class,attrs:{"id":_vm.id}},[_c('div',{staticClass:"inner"},[_vm._t("inner")],2),(_vm.hasIconSlot)?_c('div',{staticClass:"icon"},[_vm._t("icon")],2):_vm._e(),(_vm.hasFooterSlot)?_c('a',{staticClass:"small-box-footer",attrs:{"href":"#"}},[_vm._t("footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }